import { FormControl, FormLabel, MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { makeRandomID } from '../../../core/utils/mock.utils';
import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import ConfirmationDialog from '../../ConfirmationDialog';

interface OwnProps {
  label: string;
  defaultValue?: string[];
  options: SelectOption[];
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
  confirmationText?: string;
  confirmationTitle?: string;
}

export interface SelectOption {
  label: string;
  value: string;
}

const InputDropdown: React.FC<OwnProps> = ({
  label,
  defaultValue = '',
  options,
  onChange,
  className,
  disabled = false,
  confirmationText,
  confirmationTitle,
}) => {
  const fieldName = makeRandomID(5);
  const [state, setState] = useState(defaultValue);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [valueToConfirm, setValueToConfirm] = useState('');
  const { t } = useTranslation();

  useDefaultValueWatcher({ defaultValue, state, setState });

  const handleChange = (value: string) => {
    onChange(value);
    setState(value);
  };

  const handleSelectChange = (event: any) => {
    const selectedValue = event.target.value;
    if (confirmationText && defaultValue[0] !== selectedValue) {
      setIsConfirmationOpen(true);
      setValueToConfirm(selectedValue);
    } else {
      handleChange(selectedValue);
    }
  };
  const handleConfirm = () => {
    handleChange(valueToConfirm);
    setIsConfirmationOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmationOpen(false);
  };

  return (
    <FormControl variant="outlined" className={className}>
      <FormLabel htmlFor={fieldName}>{label}</FormLabel>
      <Select
        value={state}
        onChange={handleSelectChange}
        inputProps={{
          name: fieldName,
          id: fieldName,
        }}
        disabled={disabled}
      >
        {options.map((option: SelectOption, index: number) => (
          <MenuItem key={index} value={option.value}>
            {t(option.label)}
          </MenuItem>
        ))}
      </Select>
      <ConfirmationDialog
        open={isConfirmationOpen}
        handleClose={handleCancel}
        handleConfirmOk={handleConfirm}
        text={confirmationText ?? ''}
        title={confirmationTitle}
      />
    </FormControl>
  );
};

export default InputDropdown;
